/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The mode of the policy. 
*/
export enum ScheduleType {
  SCHEDULE_TYPE_UNSPECIFIED = 'UNSPECIFIED',
  SCHEDULE_TYPE_STANDARD = 'STANDARD',
  SCHEDULE_TYPE_PITR = 'PITR'
}
